/**
 * @param props.color : a hex color to set stroke or fills color of svg path
 * @param props.size : set the icon size, see getSize for expected values
 * @param props.className : a tailwind class the would be implemented on span tag
 */

interface PersonProps {
  color?: string
  size?: string
  className?: string
}

const IconSearch = (props: PersonProps) => {
  const { className = '', color = '#364152' } = props
  
  return (
    <span className={'flex items-center justify-center' + className}>
      <svg
        width={25}
        height={25}
        viewBox="0 0 30 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 21L16.65 16.65"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

export default IconSearch
